export const getBankAccountsQuery = () => {
    const query = `
        query{
            bankNames
            bankAccounts{
                id
                accountNumber
                bankName
                nickName
                consumerSecret
                merchantCode
                consumerSecret
                apiKey
                publicKey
                callbackUrl
                lastFullStatementCheckTs
                currentBalance
            }
        }
    `
    return query;
}

export const addBankAccountMutation = (params) => {
    let defaultParams = {
        accountNumber: "", bankName: "", nickName: "", apiKey: "", 
        consumerSecret: "", merchantCode: ""
    };
    const { 
        accountNumber, bankName, nickName, apiKey, consumerSecret, 
        merchantCode
    } = {...defaultParams, ...params};

    const mutation = `
        mutation{
            addBankAccount(
                accountNumber: "${accountNumber}", 
                bankName: "${bankName}",
                nickName:"${nickName}",
                apiKey: ${JSON.stringify(apiKey)}, 
                consumerSecret:"${consumerSecret}", 
                merchantCode: "${merchantCode}"
            ){
                status
                errors
                bankAccount{
                    id
                    accountNumber
                    bankName
                    nickName
                    merchantCode
                    consumerSecret
                    apiKey
                    publicKey
                    callbackUrl
                    lastFullStatementCheckTs
                    currentBalance
                }
            }
        }
    `;
    return mutation;
}

export const updateBankAccountMutation = (accountId, params) => {
    let defaultParams = {
        accountNumber: "", bankName: "", nickName: "", apiKey: "", 
        consumerSecret: "", merchantCode: ""
    };
    const { 
        accountNumber, bankName, nickName, 
        merchantCode, apiKey, consumerSecret, 
    } = {...defaultParams, ...params};

    const mutation = `
        mutation{
            updateBankAccount(
                accountId: ${JSON.stringify(accountId)}
                accountNumber: "${accountNumber}", 
                bankName: "${bankName}",
                nickName:"${nickName}",
                apiKey: ${JSON.stringify(apiKey)}, 
                consumerSecret:"${consumerSecret}", 
                merchantCode: "${merchantCode}"
            ){
                status
                errors
                bankAccount{
                    id
                    accountNumber
                    bankName
                    nickName
                    merchantCode
                    consumerSecret
                    apiKey
                    publicKey
                    callbackUrl
                    lastFullStatementCheckTs
                    currentBalance
                }
            }
        }
    `;
    return mutation;
}

export const deleteBankAccountMutation = (accountIds) => {
    const mutation = `
        mutation{
            deleteBankAccount(accountIds:${JSON.stringify(accountIds)}){
                status
                errors
            }
        }
    `;
    return mutation;
}

export const fetchBankAccountStatementQuery = (accountIds) => {
    const mutation  = `
        mutation{
            fetchAccountStatements(accountIds:${JSON.stringify(accountIds)}){
                status
                errors
                bankAccounts{
                    id
                    accountNumber
                    bankName
                    nickName
                    merchantCode
                    consumerSecret
                    apiKey
                    publicKey
                    callbackUrl
                    lastFullStatementCheckTs
                    currentBalance
                }
            }
        }
    `;
    return mutation
}

